import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isLegacyContactAnchor } from './ContactNavigation';
import { ArrowUp } from 'lucide-react';
import './FloatingNavigation.css';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  // Paperwork uses query state inside a single scroll stage.
  const contactArrival = (pathname === '/' && hash === '#contact') || isLegacyContactAnchor(pathname, hash);
  const scrollKey = pathname === '/paperwork' ? pathname : pathname + search;
  const previousScrollKey = useRef(null);

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const routeChanged = previousScrollKey.current !== scrollKey;
    previousScrollKey.current = scrollKey;
    if (routeChanged && !contactArrival) window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    return () => {
      if ('scrollRestoration' in window.history && previousRestoration) {
        window.history.scrollRestoration = previousRestoration;
      }
    };
  }, [scrollKey, contactArrival]);

  useEffect(() => {
    const updateVisibility = () => {
      setIsVisible(window.scrollY > 640);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
      className={`site-floating-button site-back-to-top fixed bottom-5 right-5 z-50 inline-flex h-11 w-11 items-center justify-center rounded-full border border-gold/35 bg-obsidian/82 text-gold shadow-[0_14px_36px_rgba(0,0,0,0.32)] backdrop-blur transition-all duration-300 hover:border-gold hover:bg-gold hover:text-obsidian focus:outline-none focus:ring-2 focus:ring-gold/50 md:bottom-7 md:right-7 ${
        isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
      }`}
    >
      <ArrowUp className="h-4 w-4" strokeWidth={2} />
    </button>
  );
}
